import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useLang } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/api";

const inputCls = "w-full px-4 py-3 rounded-xl border border-emerald-200 bg-white focus:outline-none focus:ring-2 focus:ring-emerald-700 text-sm";

export default function MemberLogin() {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ mobile: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.mobile, form.password);
      toast.success(t.login_success);
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="member-login-page">
      <div className="bg-white rounded-2xl border border-emerald-100 shadow-sm p-8">
        <div className="text-center mb-8">
          <img src="/logo.jpeg" alt="Samata Party" className="w-16 h-16 rounded-full bg-emerald-50 object-contain p-1 mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-bold text-emerald-950" data-testid="member-login-heading">{t.login_title}</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="member-login-form">
          <div>
            <label className="block text-xs font-semibold text-emerald-900 mb-1.5 uppercase tracking-wide">{t.form_mobile}</label>
            <input required value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })}
              className={inputCls} data-testid="login-mobile-input" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-emerald-900 mb-1.5 uppercase tracking-wide">{t.form_password}</label>
            <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className={inputCls} data-testid="login-password-input" />
          </div>
          <button type="submit" disabled={loading} data-testid="member-login-submit-btn"
            className="w-full py-3.5 rounded-full bg-emerald-900 hover:bg-emerald-800 text-white font-bold transition-all disabled:opacity-60">
            {loading ? "..." : t.login_button}
          </button>
        </form>
        <p className="text-sm text-slate-500 text-center mt-6">
          {t.not_member_cta}?{" "}
          <Link to="/membership" className="text-amber-700 font-semibold hover:underline" data-testid="login-membership-link">
            {t.join_now}
          </Link>
        </p>
      </div>
    </div>
  );
}
